var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FetchErrorTransition',{attrs:{"isFetching":_vm.isFetching,"error":_vm.errorMessage}},[_c('DashboardConfiguration',{attrs:{"dashboards":_vm.dashboards,"isFetching":_vm.isFetching,"isSaving":_vm.isSaving},on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }